export const INTERVIEW_COMPLETE = 'INTERVIEW_COMPLETE';
export const SET_EVENT = 'SET_EVENT';
export const SET_INTERVAL = 'SET_INTERVAL';

const initialState = {
  interviewComplete: false,
  selectedEvent: null,
  selectedInterval: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INTERVIEW_COMPLETE:
      return {
        ...state,
        interviewComplete: true,
      };

    case SET_EVENT:
      return {
        ...state,
        selectedEvent: action.event,
      };

    case SET_INTERVAL:
      return {
        ...state,
        selectedInterval: action.interval,
      };

    default:
      return state;
  }
};

export const completeInterview = () => {
  return dispatch => {
    dispatch({
      type: INTERVIEW_COMPLETE
    });
  };
};

export const setEvent = (criticalEvent) => {
  return dispatch => {
    dispatch({
      type: SET_EVENT,
      event: criticalEvent
    });
  };
};

export const setInterval = (interval) => {
  return dispatch => {
    dispatch({
      type: SET_INTERVAL,
      interval: interval
    });
  };
};



// WEBPACK FOOTER //
// ./src/modules/interviewResult.js